import { Flex, Box, Text, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import { Carousel } from 'components';
import Slide from 'pages/shared/Project/Slide';

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'react-redux';
import { isCorporateThemeSelector } from 'modules/app/appSlice';

//region styled

const SectionTitle = styled(Text)`
  line-height: 30px;
`;

const TitleWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

const CarouselOuterWrapper = styled(Box)`
  border-radius: 15px;
`;

const CarouselWrapper = styled(Box)`
  width: 100%;
  margin: 0 auto;
  border-radius: 15px;
`;

//endregion

interface Props {
  project?: Project;
}

const CertificateSlider: FC<Props> = ({ project }) => {
  const { colors } = useTheme();
  const { t } = useTranslation('projects');
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  return (
    <Flex flexDirection="column" layerStyle="projects.certificateSliderWrapper">
      <TitleWrapper>
        <SectionTitle layerStyle="projects.certificateSectionTitle" as="h2">
          {t('certifications')}
        </SectionTitle>
      </TitleWrapper>
      <CarouselOuterWrapper layerStyle="projects.certificateCarouselOuterWrapper">
        <CarouselWrapper bg="white">
          <Carousel color={isCorporateTheme ? colors.primary[500] : undefined}>
            {(project?.certifiedBy ?? []).map(({ logoUrl, description, title }) => (
              <Slide key={logoUrl} text={description} image={logoUrl} title={title} truncateToLines={5} imagePadding />
            ))}
          </Carousel>
        </CarouselWrapper>
      </CarouselOuterWrapper>
    </Flex>
  );
};

export default CertificateSlider;
